<script>
  import { ntc } from '../../routes/design/[productSlug]/_nameThatColor.js';
  ntc.init();

  import { rgbToHex, hexToRgb } from '../../utils/colourUtils.js';

  export let selectedRgb;
  export let selectedProductColourName; // A variable if user selects a product colour name
  export let clickFn;
  export let mainColour;
  export let trim1Colour;
  export let trim2Colour;
  export let show = false;

  let selectedHex = rgbToHex(selectedRgb);
  $: colourName = ntc.name(selectedHex)[1];

  function colourChange(event) {
    selectedProductColourName = null;
    selectedHex = event.target.value;
    selectedRgb = hexToRgb(selectedHex);

    // create item for clickFn
    let item = {
      name: colourName,
      rgb: selectedRgb,
    };
    clickFn(item);
  }

  function selectProductColour(colour) {
    selectedRgb = colour.rgb;
    selectedHex = rgbToHex(selectedRgb);

    selectedProductColourName = colour.name;

    // create item for clickFn
    let item = {
      name: colour.name,
      rgb: colour.rgb,
    };
    clickFn(item);
  }
</script>

<div class="component">
  <div
    class="item"
    on:click={() => {
      show = !show;
    }}
  >
    <span class="color" style="background-color: rgb{selectedRgb};"> &nbsp; </span>
    {selectedProductColourName ? selectedProductColourName : colourName}
  </div>

  {#if show}
    <div class="colour-selection">
      <div class="picker-heading">Select Colour</div>
      <div class="section-label">Product Colours</div>
      <div class="product-colours">
        <div class="product-colour" on:click={() => selectProductColour(mainColour)}>
          <div class="color" style="background-color: rgb{mainColour.rgb};" />
          <div class="product-colour-label">{mainColour.name}</div>
        </div>
        {#if trim1Colour}
          <div class="product-colour" on:click={() => selectProductColour(trim1Colour)}>
            <div class="color" style="background-color: rgb{trim1Colour.rgb};" />
            <div class="product-colour-label">{trim1Colour.name}</div>
          </div>
        {/if}
        {#if trim2Colour}
          <div class="product-colour" on:click={() => selectProductColour(trim2Colour)}>
            <div class="color" style="background-color: rgb{trim2Colour.rgb};" />
            <div class="product-colour-label">{trim2Colour.name}</div>
          </div>
        {/if}
      </div>
      <div class="picker-wrapper">
        <div class="cp-wrapper">
          <input type="color" value={selectedHex} on:input={colourChange} />
        </div>
        <div class="picker-label">Click to Pick Colour</div>
      </div>
    </div>
  {/if}
</div>

<style>
  .component {
    position: relative;
  }

  .item {
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    padding: 1.2rem 1rem;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;
  }

  .color {
    width: 2rem;
    height: 2rem;
    border-radius: 0.5rem;
    padding-right: 0.5rem;
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .product-colours {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    padding-bottom: 1rem;
    border-bottom: 1px solid rgb(0, 0, 0, 0.15);
  }

  .product-colour {
    text-align: center;
  }

  input[type='color'] {
    padding: 0;
    width: 150%;
    height: 150%;
    margin: -25%;
    cursor: pointer;
  }

  .picker-wrapper {
    margin-top: 1rem;
    display: flex;
    align-items: center;
  }

  .cp-wrapper {
    overflow: hidden;
    width: 2em;
    height: 2em;
    /* optional formatting below here */
    border-radius: 50%;
    box-shadow: 1px 1px 3px 0px grey;
    cursor: pointer;
  }

  .product-colour-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #666;
    text-transform: capitalize;
  }

  .picker-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #666;
    margin-left: 1rem;
  }

  .colour-selection {
    position: absolute;
    top: 100%;
    margin-top: 1rem;
    right: 0;
    padding: 1.5rem;
    width: 100%;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
    border-radius: 0.5rem;
    z-index: 10;
    /* height: 100%; */
    max-height: 30rem;
    overflow-y: auto;
    background-color: #fff;
  }

  .picker-heading {
    font-weight: bold;
    color: #666;
    letter-spacing: 1.5px;
    font-size: 1.2rem;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    display: block;
    padding-bottom: 1rem;
    border-bottom: 1px solid rgb(0, 0, 0, 0.15);
  }

  .section-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #666;
    margin-bottom: 0.5rem;
    display: block;
  }
</style>
